import React from 'react';
import { RenderDate } from '../renders';

const TableRenderDate = (column) => (rowData) => (
  <RenderDate date={rowData[column]} />
);

export default TableRenderDate;
